import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toggleNoti, toggleError } from 'config/slice/message'

const DURATION = 2000 // toast appearing time

export default function Toast() {

    const { isNoti, noti, isError, error } = useSelector(state => state.message) // redux state
    const dispatch = useDispatch() // redux method to manipulate the state

    /**
     * toast layout renderer
     * @param {String} content messages to show
     * @param {Boolean} isErr indicate the noti type and change the style
     * @returns the layout of the toast
     */
    const toastRenderer = (content, isErr = false) => (
        <div
            className={
                isErr
                    ? "alert alert-danger position-fixed start-50 translate-middle fs-3"
                    : "alert alert-success position-fixed start-50 translate-middle fs-3"
            }
            style={{ top: "16%", zIndex: 999 }}
            role="alert"
        >
            {content}
        </div>
    )

    // disappear the toast when DURATION run out
    useEffect(() => {
        if (isNoti === true)
            window.timer = setTimeout(() => {
                dispatch(toggleNoti(false))
            }, DURATION)
        if (isError === true)
            window.timer = setTimeout(() => {
                dispatch(toggleError(false))
            }, DURATION)

        return () => {
            clearTimeout(window.timer)
        }
    }, [isNoti, isError])

    return isNoti ? toastRenderer(noti) : isError ? toastRenderer(error, true) : false
}
